import React from 'react';
import { Skeleton, Grid } from 'antd-mobile';
import './BrandSkeleton.css';

interface BrandSkeletonProps {
  count?: number;
}

const BrandSkeleton: React.FC<BrandSkeletonProps> = ({ count = 6 }) => {
  return (
    <div className="brand-skeleton-container">
      <Grid columns={2} gap={12}>
        {Array.from({ length: count }).map((_, index) => (
          <Grid.Item key={index}>
            <div className="brand-skeleton-card">
              <div className="skeleton-logo">
                <Skeleton animated className="skeleton-logo-box" />
              </div>
              <Skeleton.Title animated style={{ width: '80%' }} />
              <Skeleton.Paragraph lineCount={1} animated style={{ width: '60%' }} />
              <div className="skeleton-tag">
                <Skeleton animated style={{ width: '50px', height: '20px' }} />
              </div>
            </div>
          </Grid.Item>
        ))}
      </Grid>
    </div>
  );
};

export default BrandSkeleton;
